import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.condiciones.delete}
                postUrl={api.proyectos.config.presupuesto.condiciones.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"La Moneda de Pago ha sido eliminada con éxito."}
                title={"Eliminar Moneda de Pago"}
                buttonTitle={"Eliminar Moneda de Pago"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                danger={true}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre" disabled={true}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_Condiciones/Delete.js